import  React, { useState, useCallback } from 'react';
import { withRouter, Link } from 'react-router-dom';

import { Parallax } from "react-parallax";
import Gallery from "react-photo-gallery";
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css'; 


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons'

import LogoBar from '../partials/logo-bar'
import HtmlBanners from '../partials/htmlbanners';

const Projects = ({ project, prevSlug, nextSlug }) => {

    const [currentImage, setCurrentImage] = useState(0);
    const [modalIsOpen, setModalIsOpen] = useState(false);
  
    const openLightbox = useCallback((event, { photo, index }) => {
      setCurrentImage(index);
      setModalIsOpen(true);
    }, [])
  
    const closeLightbox = () => {
      setCurrentImage(0);
      setModalIsOpen(false);
    }

    return (
        <main className={'project project--' + project.slug}>
            <LogoBar fixed />
            <section>
                <Parallax
                    bgImageAlt={project.title}
                    bgClassName="banner__img"
                    contentClassName="banner__fg"
                    className="banner"
                    strength={200}
                    renderLayer={(percentage) => (
                        <>
                            <div className="banner__bg--container">
                                <div 
                                    className="banner__bg" 
                                    style={{ 
                                        transform: `scale(${1 + (percentage/5)}`, 
                                        'backgroundImage': 'url(' + project.banner + ')' 
                                    }}
                                />
                            </div>
                            <div 
                                className="banner__block banner__block--stripe bg-stripe"
                                style={{
                                    width: (140  - percentage) + "vw",
                                    height: percentage * 700
                                }}
                            />
                            <div 
                                className="banner__block banner__block--solid"
                                style={{
                                    borderRightWidth: (120  - percentage) + "vw",
                                    borderBottomWidth: (40 * percentage) + "vh"
                                }}
                            />
                        </>
                    )}
                >   
                    <div>
                        <h1>{ project.title }</h1>
                    </div>
                    <Link 
                        className="banner__arrow banner__arrow--left" 
                        to={{pathname:"/" + prevSlug}}
                    >
                        <div className="hover hover--project">
                            <FontAwesomeIcon icon={faArrowLeft} alt="Previous"/>
                        </div>
                    </Link>
                    <Link 
                        className="banner__arrow banner__arrow--right" 
                        to={{pathname:"/" + nextSlug}}
                    >
                        <div className="hover hover--project">
                            <FontAwesomeIcon icon={faArrowRight} alt="Next"/>
                        </div>
                    </Link>
                </Parallax>
            </section>

            <section className="project__content">
                <div className="container">
                    <div className="description">
                        <div dangerouslySetInnerHTML={{ __html: project.description }}/>
                    </div>

                    { project.cta && project.cta.length > 0 && (
                        <div className="ctas">
                            {project.cta.map((button, k) => (
                                <a href={button.link} className="btn" target="_blank" rel="noreferrer" key={k}>
                                    <div>
                                        {button.label}
                                        <FontAwesomeIcon icon={faArrowRight} alt=""/>
                                    </div>
                                </a>
                            ))}
                        </div>
                    )}
                    <div className="media">
                        { project.slug === 'marketing-campaigns' && <HtmlBanners />}
                        { project.images && project.images.length > 0 && (
                            <>
                                <Gallery 
                                    photos={project.images} 
                                    direction={project.imageGridSettings.direction}
                                    columns={window.innerWidth > 500 ? project.imageGridSettings.columns : 1}
                                    margin={window.innerWidth > 500 ? project.imageGridSettings.margin : 0}
                                    onClick={openLightbox}
                                />
                                {modalIsOpen && (
                                    <Lightbox
                                        mainSrc={project.images[currentImage].src}
                                        nextSrc={project.images[(currentImage + 1) % project.images.length]}
                                        prevSrc={project.images[(currentImage + project.images.length - 1) % project.images.length]}
                                        onCloseRequest={closeLightbox}
                                        onMovePrevRequest={() => setCurrentImage((currentImage + project.images.length - 1) % project.images.length)}
                                        onMoveNextRequest={() => setCurrentImage((currentImage + 1) % project.images.length)}
                                    />
                                )}
                            </>
                        )}
                        {project.video && (
                            <div className="video-wrapper">
                                <iframe 
                                    src={project.video} 
                                    width="100%" 
                                    height="100%"
                                    allowFullScreen={true}
                                    title="video"
                                ></iframe>
                            </div>
                        )}
                    </div>
                </div>
            </section>
        </main>
    )
}

export default withRouter(Projects)